import { buildURL } from "imgix-url-builder";
import { imageThumbnail } from "./isFilled.js";
const asImageSrc = (field, config = {}) => {
  if (field && imageThumbnail(field)) {
    return buildURL(field.url, config);
  } else {
    return null;
  }
};
export {
  asImageSrc
};
//# sourceMappingURL=asImageSrc.js.map
